import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { logError } from '@cigna/chcp/shared/util';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<any> {
    const payload = new HttpParams()
      .set('username', username)
      .set('password', password)
      .set('login-form-type', 'pwd');

    return this.http
      .post('/pkmslogin.form', payload, { observe: 'response' })
      .pipe(
        map((res) => {
          if (res.status === 200 && res.headers.get('Location') !== null) {
            return res.headers.get('Location');
          }
          throw new Error();
        }),
        catchError(logError),
      );
  }
}
